import { type IFilter } from '@/interfaces/IFilter'

class Filter implements IFilter {
  id: string

  title: string

  constructor(item: any) {
    this.id = item.id
    this.title = item.title
  }
}

export default Filter
